import { render, staticRenderFns } from "./LibraryStrategyCard.vue?vue&type=template&id=4dc1d603&scoped=true"
import script from "./LibraryStrategyCard.vue?vue&type=script&lang=js"
export * from "./LibraryStrategyCard.vue?vue&type=script&lang=js"
import style0 from "./LibraryStrategyCard.vue?vue&type=style&index=0&id=4dc1d603&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc1d603",
  null
  
)

export default component.exports